import { HOST_URL, URL_VERSION, BALANCE_VALUATIONS } from "../constants";
import get_header from "./api_header";
import {parseHeaders} from './api_header'

export function getTaxHarvestingPortfoliosSuccess(payload) {
  return {
    type: "TAX_HARVESTING_PORTFOLIOS",
    payload
  }
}
export function getTaxHarvestingSnapshotsSuccess(payload) {
  return {
    type: "TAX_HARVESTING_SNAPSHOTS",
    payload
  }
}

export function getTaxHarvestingSnapshotByIdSuccess(payload) {
  return {
    type: "TAX_HARVESTING_SNAPSHOT",
    payload
  }
}

export function getTaxHarvestingSnapshotByDateSuccess(payload) {
  return {
    type: "TAX_HARVESTING_SNAPSHOT",
    payload
  }
}

export function getTaxHarvestingPortfolios(authentication_token, groupId, success, error) {
  return dispatch => {
    const groupQuery = groupId ? `?group_id=${encodeURIComponent(groupId)}` : '';
    return fetch(HOST_URL + "/api/v1/tax_harvesting/snapshots/portfolios" + groupQuery, {
      method: "GET",
      headers: get_header(authentication_token)
    })
      .then((response) => parseHeaders(response, dispatch))
      .then(response => {
        if (response.ok) {
          response.json().then(responseJson => {
            dispatch(getTaxHarvestingPortfoliosSuccess(responseJson.portfolios));
            success(responseJson);
          });
        } else if(response.status !== 401){
          error(response.status);
        }
      })
      .catch(error => {
        error(error);
        console.error(error);
      });
  };
}

export function getTaxHarvestingSnapshots(authentication_token, portfolioId, startDate, endDate, success, error) {
  return dispatch => {
    return fetch(`${HOST_URL}/api/v1/tax_harvesting/snapshots?portfolio_id=${portfolioId}&start_date=${startDate}&end_date=${endDate}`, {
      method: "GET",
      headers: get_header(authentication_token)
    })
    .then(response => parseHeaders(response, dispatch))
    .then(response => {
        if (response.ok) {
          response.json().then(responseJson => {
            dispatch(getTaxHarvestingSnapshotsSuccess(responseJson.snapshots));
            success(responseJson.snapshots);
          });
        } else if(response.status !== 401){
          error(response.status);
        }
      })
      .catch(error => {
        error(error);
        console.error(error);
      });
  }
}


export function getTaxHarvestingSnapshotByDate({authenticationToken, portfolioId, startDate='', endDate='', valuationDate='', page='1', perPage='100', success, error}) {
  return dispatch => {
    return fetch(`${HOST_URL}/api/v1/tax_harvesting/snapshots?portfolio_id=${portfolioId}&start_date=${startDate}&end_date=${endDate}&valuation_date=${valuationDate}&page=${page}&per_page=${perPage}`, {
      method: "GET",
      headers: get_header(authenticationToken)
    })
    .then(response => parseHeaders(response, dispatch))
    .then(response => {
        if (response.ok) {
          response.json().then(responseJson => {
            dispatch(getTaxHarvestingSnapshotByDateSuccess(responseJson.snapshots));
            success(responseJson.snapshots);
          });
        } else if(response.status !== 401){
          error(response.status);
        }
      })
      .catch(error => {
        error(error);
        console.error(error);
      });
  }
}

export function createTaxHarvestingSnapshot({authenticationToken, portfolioId, startDate='', endDate='', success, error}) {
  return dispatch => {
    return fetch(`${HOST_URL}/api/v1/tax_harvesting/snapshots`, {
      method: "POST",
      headers: get_header(authenticationToken),
      body: JSON.stringify({
        portfolio_id: portfolioId,
        start_date: startDate,
        end_date: endDate
      })
    })
    .then(response => parseHeaders(response, dispatch))
    .then(response => {
      if (response.ok) {
        response.json().then(responseJson => success(responseJson.snapshot));
      } else if(response.status !== 401) {
        error(response.status);
      }
    })
    .catch(fetchError => {
      error(fetchError);
      console.error(fetchError);
    });
  }
}

export function getTaxHarvestingSnapshotById({authenticationToken, id, accountNumbers='', holdingCompanyIds='', success, error}) {
  return dispatch => {
    return fetch(`${HOST_URL}/api/v1/tax_harvesting/snapshots/${id}?account_numbers=${accountNumbers}&holding_company_ids=${holdingCompanyIds}`, {
      method: "GET",
      headers: get_header(authenticationToken)
    })
    .then(response => parseHeaders(response, dispatch))
    .then(response => {
        if (response.ok) {
          response.json().then(responseJson => {
            dispatch(getTaxHarvestingSnapshotByIdSuccess(responseJson.snapshot));
            success(responseJson.snapshot);
          });
        } else if(response.status !== 401){
          error(response.status);
        }
      })
      .catch(error => {
        error(error);
        console.error(error);
      });
  }
}


export function getTaxHarvestingLots({authenticationToken, snapshotId, accountNumbers='', holdingCompanyIds='', tickerSymbol="", positionType, page='1', perPage='100', success, error}) {
  return dispatch => {
    return fetch(`${HOST_URL}/api/v1/tax_harvesting/snapshots/${snapshotId}/lots?position_type=${positionType}&account_numbers=${accountNumbers}&holding_company_ids=${holdingCompanyIds}&ticker_symbol=${tickerSymbol}&page=${page}&per_page=${perPage}`, {
      method: "GET",
      headers: get_header(authenticationToken)
    })
    .then(response => parseHeaders(response, dispatch))
    .then(response => {
        if (response.ok) {
          response.json().then(responseJson => {
            dispatch(getTaxHarvestingSnapshotsSuccess(responseJson));
            success(responseJson);
          });
        } else if(response.status !== 401){
          error(response.status);
        }
      })
      .catch(error => {
        error(error);
        console.error(error);
      });
  }
}
